<template>
    <v-dialog v-model="dialogOpen" max-width="500px">
        <v-card>
            <toolbar-page title="Current tenant" disable-icon>
                <template slot="buttons">
                    <v-tooltip top color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" @click="dialogOpen=false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close</span>
                    </v-tooltip>
                </template>
            </toolbar-page>

            <v-list>

                <v-list-item>
                    <v-list-item-action>
                        <v-icon>mdi-information</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Panel name</v-list-item-title>
                        <v-list-item-subtitle v-text="tenant.panel_name"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-action>
                        <v-icon>mdi-information</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Fully qualified domain name</v-list-item-title>
                        <v-list-item-subtitle v-text="tenant.fqdn"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-action>
                        <v-icon>mdi-fingerprint</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Website UUID</v-list-item-title>
                        <v-list-item-subtitle v-text="tenant.uuid"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-action>
                        <v-icon>mdi-access-time</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Created at</v-list-item-title>
                        <v-list-item-subtitle v-if="tenant.created_at">
                            {{ toHumanFrom(tenant.created_at) }} - ( {{
                            toLocalDateTime(tenant.created_at) }} )
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

            </v-list>

        </v-card>
    </v-dialog>
</template>

<script>

    import {timeDisplay} from '../../../components/mixins/timeDisplayMixin';
    import ToolbarPage from '../../../components/UI/ToolbarPage';

    export default {

        mixins: [timeDisplay],

        components: {
            ToolbarPage,
        },

        props: {
            value: {
                type: Boolean,
                default: false,
                required: true
            },
            tenant: {
                type: Object,
                required: false,
                default: () => ({
                    updated_at: null,
                    created_at: null,
                    uuid: null,
                    fqdn: null
                })
            }
        },

        computed: {
            dialogOpen: {
                get() {
                    return this.value;
                },
                set() {
                    this.closeDialog();
                }
            }
        },

        methods: {
            closeDialog() {
                this.$emit('input', false);
            }
        }
    }
</script>
